export interface MailRegistrationState {
    emailAddress: string
}

export const InitialState: MailRegistrationState = {
    emailAddress: ''
}
